package com.anjuros.website.templates.template5.sections

import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import com.anjuros.website.components.language.LocalText
import com.anjuros.website.templates.template5.components.Template5SectionTitle
import com.anjuros.website.templates.template5.modules.Template5FAQ
import com.anjuros.website.templates.template5.modules.Template5HeaderItem
import com.anjuros.website.templates.template5.modules.Template5Theme
import com.anjuros.website.templates.template5.modules.getColor
import com.anjuros.website.templates.template5.modules.getColorOpacity
import com.anjuros.website.templates.template5.styles.Template5FAQColumnStyle
import com.anjuros.website.templates.template5.styles.Template5FAQStyle
import com.anjuros.website.templates.template5.util.ResKey
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.Overflow
import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.foundation.layout.Spacer
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.id
import com.varabyte.kobweb.compose.ui.modifiers.lineHeight
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.maxHeight
import com.varabyte.kobweb.compose.ui.modifiers.maxWidth
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.modifiers.opacity
import com.varabyte.kobweb.compose.ui.modifiers.overflow
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.transition
import com.varabyte.kobweb.compose.ui.modifiers.translateY
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.framework.annotations.DelicateApi
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.style.toModifier
import com.varabyte.kobweb.silk.theme.breakpoint.rememberBreakpoint
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.ms
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.rgb
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Span
import org.jetbrains.compose.web.dom.Text

@Composable
fun Template5FaqSection() {

    Column(
        modifier = Modifier
            .id(Template5HeaderItem.FAQ.id)
            .fillMaxWidth()
            .padding(
                topBottom = 120.px,
                leftRight = 24.px
            ),
        horizontalAlignment = Alignment.CenterHorizontally
    ) {

        Template5SectionTitle(
            badge = ResKey.TEMPLATE5_FAQ_BADGE,
            title = ResKey.TEMPLATE5_FAQ_TITLE,
            text = ResKey.TEMPLATE5_FAQ_TEXT
        )

        Spacer()

        Column(
            modifier = Template5FAQColumnStyle.toModifier(),
            verticalArrangement = Arrangement.spacedBy(18.px),
            horizontalAlignment = Alignment.CenterHorizontally
        ) {

            Template5FAQ.entries.forEach {

                Template5FaqItem(it)

            }

        }

    }

}

@OptIn(DelicateApi::class)
@Composable
private fun Template5FaqItem(
    faq: Template5FAQ
) {

    var expanded by remember {
        mutableStateOf(false)
    }

    var breakpoint = rememberBreakpoint()

    Column(

        modifier = Template5FAQStyle.toModifier()
            .borderRadius(24.px)
            .backgroundColor(Template5Theme.Background.getColorOpacity())
            .border(
                1.px,
                LineStyle.Solid,
                rgb(240,232,228)
            )
            .cursor(Cursor.Pointer)
            .padding(28.px)
            .onClick {
                expanded = !expanded
            },
        verticalArrangement = Arrangement.Center,
        horizontalAlignment = Alignment.CenterHorizontally

    ) {

        Row(
            modifier = Modifier.fillMaxWidth(),
            verticalAlignment = Alignment.CenterVertically
        ) {

            Span(
                attrs = Modifier
                    .fontSize(22.px)
                    .fontWeight(FontWeight.Bold)
                    .color(Template5Theme.Primary.getColor())
                    .toAttrs()
            ) {
                Text(if (expanded) "−" else "+")
            }

            Span(
                attrs = Modifier
                    .margin(left = 18.px)
                    .fontSize(20.px)
                    .fontWeight(FontWeight.SemiBold)
                    .toAttrs()
            ) {
                Text(LocalText(faq.question))
            }

        }



            P(
                attrs = Modifier
                    .overflow(Overflow.Hidden)
                    .height(
                        if (expanded) (if(breakpoint>=Breakpoint.LG) 120.px else 160.px) else 0.px
                    )
                    .opacity(
                        if (expanded) 1 else 0
                    )
                    .translateY(
                        if (expanded) 0.px else 8.px
                    )
                    .transition(
                        Transition.of("height", 400.ms),
                        Transition.of("opacity", 450.ms),
                        Transition.of("transform", 400.ms)
                    )
                    .margin(top = if(expanded)22.px else 0.px)
                    .fontSize(17.px)
                    .lineHeight(1.8)
                    .color(rgb(100,100,100))
                    .toAttrs()
            ) {
                Text(LocalText(faq.answer))
            }


    }

}